import {
  useState,
  useMemo,
  useCallback,
  MouseEventHandler
} from 'react';
import { text } from '../../../../text';
import {
  FavouriteButtonClicked,
  SaleButtonClicked
} from '../../../../services/dispatchers';

export const useEmptyCartPage = () => {
  const [hasFavorite, setHasFavorite] = // eslint-disable-line
    useState<boolean>(false);
  const [hasSales, setHasSales] = useState<boolean>(false); // eslint-disable-line

  const onClickFavouriteButton = useCallback<
    MouseEventHandler<HTMLButtonElement>
  >(() => {
    FavouriteButtonClicked.dispatch();
  }, []);

  const onClickSaleButton = useCallback<
    MouseEventHandler<HTMLButtonElement>
  >(() => {
    SaleButtonClicked.dispatch();
  }, []);

  const [
    description,
    additionalButtonText,
    onClickAdditionalButton
  ] = useMemo(() => {
    if (hasFavorite) {
      return [
        text['cart.empty.textFavorite'],
        text['button.goToFavorite'],
        onClickFavouriteButton
      ];
    }

    if (hasSales) {
      return [
        text['cart.empty.textSales'],
        text['button.goToSales'],
        onClickSaleButton
      ];
    }

    return [text['cart.empty.text'], '', undefined];
  }, [
    hasFavorite,
    hasSales,
    onClickFavouriteButton,
    onClickSaleButton
  ]);

  return {
    description,
    additionalButtonText,
    onClickAdditionalButton
  };
};
